import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import * as moment from "moment-timezone";
import { DriverLoadV2Component } from '../driver-load-v2/driver-load-v2.component';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { checkRole } from 'src/app/utils/utils.common';
import { ViolationService } from '../../violations-sets/violation-service/violation.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { BreakModalService } from 'src/app/modals/break-modal/break-modal-service/break-modal.service';
import { ActivatedRoute } from '@angular/router';
import { DriverLoadV3Component } from '../driver-load-v3/driver-load-v3.component';

@Component({
  selector: 'app-driver-load-wrapper',
  templateUrl: './driver-load-wrapper.component.html',
  styleUrls: ['./driver-load-wrapper.component.css']
})
export class DriverLoadWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('driverLoad', { static: false }) dl: DriverLoadV3Component;
  wrapper = 'driverLoad';
  version = '2';

  constructor(
    private assignTripService: AssigTripsService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private violatioServie: ViolationService,
    private socketService: SocketService,
    private breakService : BreakModalService,
    private activatedRoute: ActivatedRoute
  ) { 
    // const param = this.activatedRoute.snapshot.params['version'];
    // if (param && param === 'v2') {
    //   this.version = '3';
    // }
  }

  ngOnInit() {
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.dl.getLevelOfService(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.dl.getSpaceTypes(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getCorporate(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getStaffList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dl.getServiceAreas(data);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getDrivers(data) {
    this.driverService
      .getDrivers(data.userId, data.endPoint, true)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getDriverList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getAllTrips(payload) {
    this.assignTripService
      .getOutstandingTrips(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getAllTrips(data);
        }
      })
  }

  getDriverTimelines(queryString) {
    this.driverService
      .getDriverTimelines(queryString)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        this.dl.getDriverTimelines(data);
      });
  }

  processBucket(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.processBucket(data);
        } else if (data) {
          sweetAlert('Error', data, 'warning', 'OK');
        }
      });
  }

  getNearbyDriver(payload) {
    this.driverService
      .getNearbyDrivers(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getNearbyDriversRes(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getViolationData() {
    this.violatioServie.getViolationData().subscribe((data) => {
      if (data) {
        this.dl.getViolationData(data);
      }
    })
  }

  cancelTrip(payload) {
    this.assignTripService
      .removeTrip(payload, payload._id)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.cancelTrip(payload, data);
        }
      });
  }

  driverBreak(payload) {
    this.breakService
    .addDriverBreak(payload).pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.dl.onBreakModelClose();
      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  ngOnDestroy() {
  }
}
